type RuntimeEnvKey =
  | "REACT_APP_API_URL"
  | "REACT_APP_MAPS_API_KEY"
  | "REACT_APP_PAYPAL_CLIENT_ID"
  | "REACT_APP_PAYPAL_PLAN_ID_FREE"
  | "REACT_APP_PAYPAL_PLAN_ID_PRO"
  | "REACT_APP_PAYPAL_PLAN_ID_ELITE";

declare global {
  interface Window {
    __ENV__?: Partial<Record<RuntimeEnvKey, string>>;
  }
}

function readRuntimeEnv(key: RuntimeEnvKey): string {
  if (typeof window === "undefined" || !window.__ENV__) return "";
  const value = window.__ENV__[key];
  return typeof value === "string" ? value.trim() : "";
}

export function getRuntimeEnv(key: RuntimeEnvKey): string {
  const fromWindow = readRuntimeEnv(key);
  if (fromWindow) return fromWindow;

  const fromBuild = process.env[key];
  return typeof fromBuild === "string" ? fromBuild.trim() : "";
}
